module.exports = __webpack_public_path__ + "img/CycleManagerJavaWebStart.50b60b61.png";